// import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DrGayatriNavaleContent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "32px",
            textAlign: "left",
          }}
        >
          <img
            src="/Doctorprofile.png"
            alt="Dr. Gayatri Navale"
            style={{
              width: "220px",
              height: "220px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #ddd",
              flexShrink: 0,
            }}
          />

          <div
            className="vertical-divider"
            style={{
              width: "2px",
              backgroundColor: "#ccc",
              height: "100%",
              minHeight: "160px",
              display: "none",
            }}
          ></div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              flex: 1,
              minWidth: "260px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
              className="content-container"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
                className="inner-content"
              >
                <div style={{ flex: 1 }}>
                  <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Dr. Gayatri Navale
                  </h2>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Specialization:</strong> Your Safe Space to Share
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Experience:</strong> 13 Years
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Degrees:</strong> MBBS, MS (Obs & Gyn) from University Name
                  </p>
                </div>

                <div
                  className="vertical-divider"
                  style={{
                    width: "2px",
                    backgroundColor: "#ccc",
                    height: "100%",
                    minHeight: "160px",
                    display: "none",
                  }}
                ></div>

                <div style={{ flex: 1 }}>
                  <p
                    style={{
                      fontStyle: "italic",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      color: "#444",
                      marginTop: "4px",
                    }}
                  >
                    "There is no such thing as a 'silly question' or a 'small fear'. In our conversations, everything is valid, and everything matters. I am here to listen."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <style>
      {`
        @media (min-width: 768px) {
          .vertical-divider {
            display: block !important;
          }
    
          .inner-content {
            flex-direction: row !important;
          }
        }
    
        @media (max-width: 767px) {
          .doctor-intro-container {
            flex-direction: column;
            align-items: center !important;
            text-align: center !important;
          }
    
          .inner-content {
            flex-direction: column !important;
            align-items: center !important;
            text-align: center !important;
          }
    
          .content-container {
            align-items: center !important;
            text-align: center !important;
          }
        }
      `}
    </style>
    

      <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
        <h3>My Philosophy on Pregnancy Care:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          My entire practice is built on a foundation of empathy. I understand that pregnancy brings a whirlwind of emotions, and my primary role is to create a safe, confidential space where you can voice every single one. I listen more than I talk. By truly hearing you, I can better understand your needs and we can navigate this path as a team, with trust and mutual respect at the core of everything we do.
        </p>

        <h3 style={{ marginTop: "32px" }}>Why I Chose Myprega:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          The Myprega philosophy of "care like a mother" is what medicine should be. The system's emphasis on regular, personal calls and counselling allows me to do what I do best: listen and connect. It formalizes the empathetic approach that I believe is the most critical, yet often overlooked, part of a mother's journey.
        </p>

        <h3 style={{ marginTop: "32px" }}>Beyond the Clinic:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          I volunteer at a local animal shelter on weekends; caring for the voiceless is a passion of mine. I find journaling to be incredibly therapeutic and I encourage my patients to do the same. I'm currently reading a lot of Brené Brown's work on vulnerability and courage.
        </p>
      </div>

      <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "24px",
            paddingTop: "32px",
          }}
        >
          {/* Favourite Book */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              📖 Favourite Book
            </p>
            <p style={{ color: "#333" }}>Daring Greatly by Brené Brown</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Singer */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🎵 Favourite Singer
            </p>
            <p style={{ color: "#333" }}>Shreya Ghoshal</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Pastime */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🐶 Favourite Pastime
            </p>
            <p style={{ color: "#333" }}>
              Volunteering at the animal shelter <br />
              Reflective journaling
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DrGayatriNavaleContent;
